import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Api from '../../common/services/api.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' })
};

@Injectable()
export  class AuthentificationService {

    
    endpoint = 'client/token';

    constructor(private api: Api) { }

    attemptAuth(login: string, password: string): Observable<any> {
        const credentials = {login: login, pwd: password};
        return this.api.post(this.endpoint, credentials); 

    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/services/authentification.service.ts